export default __webpack_public_path__ + "images/821ac1859ecbf0ab59214c7d7157610d.svg";